import { CalendarDays, Repeat2 } from 'lucide-react';
import type { ComponentProps, ReactNode } from 'react';

import { FinanceCoin } from './FinanceCoin';

export function OperationSelectionCard({ title, children, variant }: { title: string; children: ReactNode; variant?: 'debt-category' }) {
  return <section className={`operation-selection-card${variant ? ` ${variant}` : ''}`}><header>{title}</header><div>{children}</div></section>;
}

function unavailableAmount() { return '—'; }

export function OperationCoin({ selected, onClick, amount, ...coin }: Omit<ComponentProps<typeof FinanceCoin>, 'active' | 'amount'> & { amount: number | undefined; selected: boolean; onClick: () => void }) {
  return <button type="button" className="operation-coin" aria-pressed={selected} onClick={onClick}><FinanceCoin {...coin} amount={amount ?? 0} formatAmount={amount === undefined ? unavailableAmount : coin.formatAmount} active={selected} /></button>;
}

export function OperationDetails({ transfer = false, noteInput, dateInput }: { transfer?: boolean; noteInput: ReactNode; dateInput?: ReactNode }) {
  return (
    <section className="operation-details">
      {transfer ? <label><Repeat2 size={19} />{noteInput}</label> : <>
        {dateInput ? <div className="operation-date-row editable"><CalendarDays size={19} /><strong>Дата и время</strong>{dateInput}</div> : <div className="operation-date-row"><CalendarDays size={19} /><strong>Дата и время</strong><span>{new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }).format(new Date())}</span></div>}
        <label>{noteInput}</label>
      </>}
    </section>
  );
}
